import React from 'react';
import PropTypes from 'prop-types';
import { colors, Tooltip } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useTranslation } from 'react-i18next';
import { dateTimeHuman } from 'utils';

/**
 * THE ADDRESS WAS PROVED FROM ITS OWN INBOX (25 Oct 2026: «якщо адреса
 * підтверджена, давай показувати зелену галку біля адреси»). Renders only
 * the mark; whether to show it is the caller's — `emailVerified` from the
 * server, never re-derived here. The date is in the hint when the server
 * sent one.
 */
const EmailVerifiedMark = ({ verifiedAt, className }) => {
  const [t] = useTranslation();
  const title = verifiedAt
    ? t('component.emailVerifiedMark.verifiedOn', { date: dateTimeHuman(verifiedAt) })
    : t('component.emailVerifiedMark.verified');

  return (
    <Tooltip title={title}>
      <CheckCircleIcon
        aria-label={title}
        className={className}
        data-testid="email-verified-mark"
        fontSize={className ? 'inherit' : 'small'}
        style={{ color: colors.green[600], flexShrink: 0 }}
      />
    </Tooltip>
  );
};

EmailVerifiedMark.propTypes = {
  className: PropTypes.string,
  verifiedAt: PropTypes.string,
};

export default EmailVerifiedMark;
